import { Box, Grid, styled } from "@mui/material";

export const ListGrid = styled(Grid)(({ theme }) => ({
    // borderRight: '1px solid',
    // borderLeft: '1px solid #E5E5E7',
}))

export const BoxList = styled(Box)(({ theme }) => ({
    // borderRight: '1px solid',
    borderLeft: '1px solid #E5E5E7',
    height: "100%"

}))
export const HeadList = styled(Box)(({ theme }) => ({
    color: "#FFFFFF",
    background: "#026735",
    padding: '12px',
    textAlign: 'center'

}))
export const List = styled(Box)(({ theme }) => ({
    '.item-list': {
        
        // borderTop: '1px solid',
        borderBottom: '1px solid #E5E5E7',
        cursor: 'pointer',
        padding: '12px',
        ':hover': {
            background: '#EFFFF7'
        },
        '.icon-list': {
            marginRight: '12px'
        }
    },

}))
export const ItemList = styled(Box)(({ theme }) => ({

}))